import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditMaskForm from './EditMaskForm'
import ModalHeader from './ModalHeader'
import MasksLoader from './_load/MasksLoader'

const EditMaskModal = props => {
  return (
    <ControlledModal width="42rem" {...props}>
      <PermissionChecker module="masks" name="edit">
        <ModalHeader />
        <MasksLoader>
          <EditMaskForm />
        </MasksLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditMaskModal
